import React from 'react';
import {observer} from 'mobx-react';
import {FooterModuleDisclaimer} from "../footer-module.disclaimer";
import {FooterModuleLinks} from "../footer-module.links";
import classNames from "classnames";
import styles from "../../styles/footer.module.scss";

export const FooterModuleDesktopContent = observer(({controller, onItemClick}) => {
  const {state: {allLinks}} = controller;

  const linksProps = {
    controller,
    links: allLinks,
    onItemClick: (link) => onItemClick && onItemClick(link)
  }

  return (
    <div className={classNames(styles.bottom_content)}>
      <div className={classNames(styles.bottom_content_links, styles.links)}>
        <FooterModuleLinks {...linksProps}/>
      </div>
      <FooterModuleDisclaimer controller={controller}/>
    </div>
  );
});
